import React from 'react'
import styled from 'styled-components'

import PaymentsSVG from 'assets/svg/landing/payments.svg'
import UniversalCheckoutSVG from 'assets/svg/landing/universal-checkout.svg'
import ConnectionsSVG from 'assets/svg/landing/connections.svg'
import WorkflowsSVG from 'assets/svg/landing/workflows.svg'

import ApplePayLogo from 'assets/svg/landing/logos/apple-pay.svg'
import AdyenLogo from 'assets/svg/landing/logos/adyen.svg'
import BancontactLogo from 'assets/svg/landing/logos/bancontact.svg'
import BraintreeLogo from 'assets/svg/landing/logos/braintree.svg'
import BuckarooLogo from 'assets/svg/landing/logos/buckaroo.svg'
import CardLogo from 'assets/svg/landing/logos/card.svg'
import CoinbaseLogo from 'assets/svg/landing/logos/coinbase.svg'
import GooglePayLogo from 'assets/svg/landing/logos/google-pay.svg'
import IDealLogo from 'assets/svg/landing/logos/ideal.svg'
import IngenicoLogo from 'assets/svg/landing/logos/ingenico.svg'
import KlarnaLogo from 'assets/svg/landing/logos/klarna.svg'
import MollieLogo from 'assets/svg/landing/logos/mollie.svg'
import PayNlLogo from 'assets/svg/landing/logos/pay-nl.svg'
import PaypalLogo from 'assets/svg/landing/logos/paypal.svg'
import RapydLogo from 'assets/svg/landing/logos/rapyd.svg'
import StripeLogo from 'assets/svg/landing/logos/stripe.svg'
import ThreeDSLogo from 'assets/svg/landing/logos/three-d-secure.svg'
import WorldpayLogo from 'assets/svg/landing/logos/worldpay.svg'

import AndroidLogo from 'assets/svg/landing/logos/android.svg'
import IOSLogo from 'assets/svg/landing/logos/ios.svg'
import ReactNativeLogo from 'assets/svg/landing/logos/react-native.svg'
import WebSDKLogo from 'assets/svg/landing/logos/web-sdk.svg'

import PaySVG from 'assets/svg/landing/pay.svg'
import ThreeDSSvg from 'assets/svg/landing/threeds.svg'
import VaultSVG from 'assets/svg/landing/vault.svg'
import ComplianceSVG from 'assets/svg/landing/compliance.svg'

import PaymentsOrchestrationSVG from 'assets/svg/landing/payments-orchestration.svg'
import ShippingLogisticsSVG from 'assets/svg/landing/shipping-logistics.svg'
import LoyaltyRewardsSVG from 'assets/svg/landing/loyalty-rewards.svg'
import OperationalEfficiencySVG from 'assets/svg/landing/operational-efficiency.svg'

const StyledConnectionsSVG = styled(ConnectionsSVG)`
	width: 100%;
	left: unset !important;
	right: -163px;
`

const StyledUniversalCheckoutSVG = styled(UniversalCheckoutSVG)`
	top: 0 !important;

	${p => p.theme.above('extraLarge')`
    right: 11px !important;
  `}
`

const StyledWorkflowsSVG = styled(WorkflowsSVG)`
	top: -10px !important;
`

export const features = [
	{
		title: 'Payments',
		description: 'Learn payments only once and manage your entire stack in a unified way.',
		link: '/how-primer-works/payments',
		illustration: <PaymentsSVG />,
	},
	{
		title: 'Universal Checkout',
		description: 'Integrate our dynamic, fully customizable checkout for web and mobile.',
		link: '/how-primer-works/universal-checkout',
		illustration: <StyledUniversalCheckoutSVG />,
	},
	{
		title: 'Connections',
		description: 'Choose from our ever-growing library of payment and commerce integrations.',
		link: '/how-primer-works/connections',
		illustration: <StyledConnectionsSVG />,
	},
	{
		title: 'Workflows',
		description: 'Build sophisticated payment flows without a single line of code.',
		link: '/how-primer-works/workflows',
		illustration: <StyledWorkflowsSVG />,
	},
]

export const paymentsUsps = [
	{
		icon: <PaySVG />,
		description: 'Countless processors & payment methods ',
	},
	{
		icon: <ThreeDSSvg />,
		description: 'Unified 3D Secure across all processors',
	},
	{
		icon: <VaultSVG />,
		description: 'Centralized vault ',
	},
	{
		icon: <ComplianceSVG />,
		description: 'PCI-1 & GDPR compliant',
	},
]

// Add logos
export const automationUsps = [
	{
		icon: <PaymentsOrchestrationSVG />,
		description: 'Payments orchestration',
	},
	{
		icon: <ShippingLogisticsSVG />,
		description: 'Shipping & logistics',
	},
	{
		icon: <LoyaltyRewardsSVG />,
		description: 'Loyalty & rewards',
	},
	{
		icon: <OperationalEfficiencySVG />,
		// Talk about cstomer support
		description: 'Streamline operations and support',
	},
]

export const paymentMethods = [
	{
		name: 'Google Pay',
		logo: <GooglePayLogo />,
	},
	{
		name: 'Klarna',
		logo: <KlarnaLogo />,
	},
	{
		name: 'PayPal',
		logo: <PaypalLogo />,
	},
	{
		name: 'Credit cards',
		logo: <CardLogo />,
	},
	{
		name: 'Coinbase',
		logo: <CoinbaseLogo />,
	},
	{
		name: 'iDeal',
		logo: <IDealLogo />,
	},
	{
		name: 'Bancontact',
		logo: <BancontactLogo />,
	},
	{
		name: 'Apple Pay',
		logo: <ApplePayLogo />,
	},
]

export const compatibleServices = [
	{
		name: 'Credit Cards',
		logo: <CardLogo />,
	},
	{
		name: 'Google Pay',
		logo: <GooglePayLogo />,
	},
	{
		name: 'Apple Pay',
		logo: <ApplePayLogo />,
	},
	{
		name: '3D Secure',
		logo: <ThreeDSLogo />,
	},
]

export const paymentProcessors = [
	{
		name: 'Adyen',
		logo: <AdyenLogo />,
	},
	{
		name: 'Ingenico',
		logo: <IngenicoLogo />,
	},
	{
		name: 'Stripe',
		logo: <StripeLogo />,
	},
	{
		name: 'Braintree',
		logo: <BraintreeLogo />,
	},
	{
		name: 'Paypal',
		logo: <PaypalLogo />,
	},
	{
		name: 'Pay.',
		logo: <PayNlLogo />,
	},
	{
		name: 'Worldpay',
		logo: <WorldpayLogo />,
	},
	{
		name: 'Buckaroo',
		logo: <BuckarooLogo />,
	},
	{
		name: 'Mollie',
		logo: <MollieLogo />,
	},
	{
		name: 'Rapyd',
		logo: <RapydLogo />,
	},
]

export const sdks = [
	{
		name: 'Web JS',
		logo: <WebSDKLogo />,
		link: '/payments/universal-checkout/drop-in/get-started/web',
	},
	{
		name: 'iOS',
		logo: <IOSLogo />,
		link: '/payments/universal-checkout/drop-in/get-started/ios',
	},
	{
		name: 'Android',
		logo: <AndroidLogo />,
		link: '/payments/universal-checkout/drop-in/get-started/android',
	},
	{
		name: 'React Native',
		logo: <ReactNativeLogo />,
		link: '/payments/universal-checkout/drop-in/get-started/react-native',
	},
]

export const paymentGuides = [
	{
		title: 'Process payments',
		description: 'Begin processing payments with Primer in a few minutes.',
		imgSrc: require('../assets/process-payments.png').default,
		link: '/payments/process-payments',
	},
	{
		title: 'Primer concepts',
		description: 'Learn payments once and unify your payment lifecycle across all processors.',
		imgSrc: require('../assets/how-payments-work.png').default,
		link: '/payments/primer-concepts',
	},

	{
		title: 'Universal Checkout',
		description: 'Unify your checkout experience with any payment method across web and mobile.',
		imgSrc: require('../assets/universal-checkout.png').default,
		link: '/payments/universal-checkout',
	},
]

export const automationGuides = [
	{
		title: 'Create workflow',
		// Description need work
		description: 'Bring apps into sophisticated flows without a single line of code.',
		imgSrc: require('../assets/create-workflow.png').default,
		link: '/automation/create-workflow',
	},
	{
		title: 'Connect apps',
		// Description need work
		description: 'Supercharge your flow with our ever-growing library of apps.',
		imgSrc: require('../assets/connect-apps.png').default,
		link: '/automation/workflow-apps',
	},

	{
		title: 'Discover templates',
		// Talk about "discover""
		description: 'Get started with our library of templates.',
		imgSrc: require('../assets/discover-templates.png').default,
		link: '/automation/templates',
	},
]
